import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-adminapp',
    templateUrl: './adminapp.component.html',
    styleUrls: ['./adminapp.component.scss'],
    standalone: false
})
export class AdminappComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const userAgent = navigator.userAgent || (window as any).opera;
    if (/android/i.test(userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.echo.featherbar';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !('MSStream' in window)) {
      window.location.href = 'https://apps.apple.com/us/app/feather-admin/id6744312955';
    }
  }

}
